import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  detail: {},
  analytics: {},
};

export const counterSlice = createSlice({
  name: "campaigns",
  initialState,
  reducers: {
    setDetail: (state, action) => {
      state.detail = action.payload;
    },
    setList: (state, action) => {
      state.list = action.payload;
    },
    setAnalytics: (state, action) => {
      state.analytics = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setList, setDetail, setAnalytics } = counterSlice.actions;

export default counterSlice.reducer;
